import {
  AnalyticsEventBase,
  AudioChangeEvent,
  ErrorEvent,
  SourceChangeEvent,
  VideoChangeEvent,
} from '../types/EventData';

export enum Event {
  SETUP = 'setup',
  READY = 'ready',
  SOURCE_LOADED = 'sourceLoaded',
  PLAY = 'play',
  PLAYING = 'playing',
  PAUSE = 'pause',
  TIMECHANGED = 'timechanged',
  SEEK = 'seek',
  SEEKED = 'seeked',
  START_CAST = 'startCasting',
  END_CAST = 'endCasting',
  START_BUFFERING = 'startBuffering',
  END_BUFFERING = 'endBuffering',
  AUDIOTRACK_CHANGED = 'audioTrackChanged',
  AUDIO_CHANGE = 'audioChange',
  VIDEO_CHANGE = 'videoChange',
  START_FULLSCREEN = 'startFullscreen',
  END_FULLSCREEN = 'endFullscreen',
  START_AD = 'adStart',
  SUBTITLE_CHANGE = 'subtitleChange',
  END_AD = 'adEnd',
  MUTE = 'mute',
  UN_MUTE = 'unMute',
  ERROR = 'playerError',
  SCREEN_RESIZE = 'resize',
  UNLOAD = 'unload',
  END = 'end',
  SOURCE_UNLOADED = 'sourceUnloaded',
  MANUAL_SOURCE_CHANGE = 'manualSourceChangeInitiated',
  VIDEOSTART_TIMEOUT = 'VIDEOSTART_TIMEOUT',
  CUSTOM_DATA_CHANGE = 'customDataChange',
  PLAYLIST_TRANSITION = 'playlistTransition',
}

export interface EventMap {
  [Event.SETUP]: AnalyticsEventBase;
  [Event.READY]: AnalyticsEventBase;
  [Event.SOURCE_LOADED]: AnalyticsEventBase;
  [Event.PLAY]: AnalyticsEventBase;
  [Event.PLAYING]: AnalyticsEventBase;
  [Event.PAUSE]: AnalyticsEventBase;
  [Event.TIMECHANGED]: AnalyticsEventBase;
  [Event.SEEK]: AnalyticsEventBase;
  [Event.SEEKED]: AnalyticsEventBase;
  [Event.START_CAST]: AnalyticsEventBase;
  [Event.END_CAST]: AnalyticsEventBase;
  [Event.START_BUFFERING]: AnalyticsEventBase;
  [Event.END_BUFFERING]: AnalyticsEventBase;
  [Event.AUDIOTRACK_CHANGED]: AnalyticsEventBase;
  [Event.AUDIO_CHANGE]: AudioChangeEvent;
  [Event.VIDEO_CHANGE]: VideoChangeEvent;
  [Event.START_FULLSCREEN]: AnalyticsEventBase;
  [Event.END_FULLSCREEN]: AnalyticsEventBase;
  [Event.START_AD]: AnalyticsEventBase;
  [Event.SUBTITLE_CHANGE]: AnalyticsEventBase;
  [Event.END_AD]: AnalyticsEventBase;
  [Event.MUTE]: AnalyticsEventBase;
  [Event.UN_MUTE]: AnalyticsEventBase;
  [Event.ERROR]: ErrorEvent;
  [Event.SCREEN_RESIZE]: AnalyticsEventBase;
  [Event.UNLOAD]: AnalyticsEventBase;
  [Event.END]: AnalyticsEventBase;
  [Event.SOURCE_UNLOADED]: AnalyticsEventBase;
  [Event.MANUAL_SOURCE_CHANGE]: SourceChangeEvent;
  [Event.VIDEOSTART_TIMEOUT]: AnalyticsEventBase;
  [Event.CUSTOM_DATA_CHANGE]: AnalyticsEventBase;
  [Event.PLAYLIST_TRANSITION]: AnalyticsEventBase;
}
